import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('fa-solid fa-minus')
}
const _hoisted_3 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass('fa-solid fa-plus')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass({'striped-row': _ctx.ind % 2 == 0})
    }, [
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expand && _ctx.expand(...args))),
          class: "btn btn-sm btn-primary",
          "data-bs-toggle": "collapse",
          "data-bs-target": '.user_jobs_' + _ctx.user.user_id,
          "aria-expanded": "false"
        }, [
          (_ctx.expanded)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : (_openBlock(), _createElementBlock("i", _hoisted_3))
        ], 8, _hoisted_1)
      ]),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.name), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.email), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.sp_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.no_show_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.learner_tech_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.late_canc_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.early_canc_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.scorecard_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.trainer_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.training_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.interview_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.author_hours), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.user.total_hours), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.sp_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.no_show_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.learner_tech_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.late_canc_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.early_canc_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.observer_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.trainer_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.training_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.interview_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.author_rate), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.sp_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.no_show_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.learner_tech_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.late_canc_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.early_canc_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.scorecard_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.trainer_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.training_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.interview_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.author_total), 1),
      _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.total), 1)
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.jobs, (job) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: job.number,
        class: _normalizeClass(['user_jobs_' + _ctx.user.user_id, "collapse job-row"])
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
        _createElementVNode("td", null, _toDisplayString(job.number), 1),
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "-", -1)),
        _createElementVNode("td", null, _toDisplayString(job.sp_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.no_show_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.learner_tech_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.late_canc_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.early_canc_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.scorecard_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.trainer_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.training_hours), 1),
        _cache[3] || (_cache[3] = _createElementVNode("td", null, "-", -1)),
        _createElementVNode("td", null, _toDisplayString(job.author_hours), 1),
        _createElementVNode("td", null, _toDisplayString(job.total_hours), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.sp_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.no_show_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.learner_tech_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.late_canc_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.early_canc_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.observer_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.trainer_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.training_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.interview_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(_ctx.user.author_rate), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.sp_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.no_show_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.learner_tech_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.late_canc_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.early_canc_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.scorecard_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.trainer_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.training_total), 1),
        _cache[4] || (_cache[4] = _createElementVNode("td", null, "-", -1)),
        _createElementVNode("td", null, "$" + _toDisplayString(job.author_total), 1),
        _createElementVNode("td", null, "$" + _toDisplayString(job.total), 1)
      ], 2))
    }), 128))
  ], 64))
}